var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AAAAAA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,2.4c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S3.8,2.4,3.3,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,15c0.7,0.3,1.5,0.4,2.3,0.4h0c1.5,0,2.9-0.4,4.1-1.3c0.8-0.6,1.5-1.4,2-2.2l0.5-0.9 c0.5-1.3,0.7-2.7,0.4-4.1c-0.3-1.4-0.9-2.7-1.9-3.7c-1-1-2.3-1.7-3.7-2C8.6,0.8,7.3,0.9,6.1,1.3c0.3,0.4,0.4,0.8,0.6,1.2 c1.6-0.5,3.3-0.3,4.7,0.6c1.5,0.9,2.6,2.5,2.8,4.2s-0.3,3.5-1.6,4.8c-1.2,1.3-3,2-4.8,1.8c-1.8-0.2-3.4-1.1-4.4-2.6 C2.6,10,2.3,8.3,2.7,6.7C2.2,6.6,1.8,6.5,1.4,6.2C1,7.6,1.1,9,1.5,10.3C2.2,12.5,3.8,14.2,6,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,9.1c0.1,0.1,0.3,0.2,0.5,0.2H11V8H8.5V5.1H7.2v3.6C7.2,8.8,7.3,9,7.4,9.1L7.4,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLogs);
export default __webpack_public_path__ + "static/media/show-logs.ea967e8e6d08ac5331d8a6a207f840bc.svg";
export { ForwardRef as ReactComponent };